
export default {
  head: {
    htmlAttrs: {
      id: 'scroll-to-top',
    },
    meta: [
      {
        name: 'robots',
        content: 'noindex',
      },
      {
        name: 'googlebot',
        content: 'noindex',
      }
    ]
  },
}
